module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_8023.4e66df9f.png";